import { StyleSheet } from 'react-native';

const style = StyleSheet.create({
  termsText: {
    fontSize: 14.6,
    lineHeight: 17,
    textAlign: 'center',
  },
  hyperLinkText: {
    textDecorationLine: 'underline',
  },
  privacyText: {
    textAlign: 'center',
  },
});
export default style;
